import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { Field, reduxForm } from 'redux-form';
import Select from 'react-select';
import {
  email,
  IndMobileNumber,
  renderField,
  required,
} from '../../common/helpers/form-validations';
import { planListView } from '../../Services/Utils/PlanApis';

export const renderSelectForPlan = (props) => (
  <div>
    <Select
      {...props}
      className="react-select__container"
      classNamePrefix="react-select"
      value={props.input.value}
      onChange={(value) => props.input.onChange(value)}
      onBlur={() => props.input.onBlur()}
      options={props.options}
      isSearchable={false}
      styles={{
        control: (base) => ({
          ...base,
          border: '1px solid #CBCBCB',
          boxShadow: 'none',
          '&:hover': {
            border: '1px solid black',
          }
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? '#DDDDDD' : 'white',
          color: '#000000'
        })
      }}
    />
    {props.meta.touched && (props.meta.error && (
      <span className="text-danger small">
        <i className="fa fa-exclamation-circle text-danger" />&nbsp;&nbsp;{props.meta.error}
      </span>
    ))}
  </div>
);

function StartUpForm(props) {
  const {
    handleSubmit, onButtonClick, startupText, invalid,
    pristine, processing
  } = props;

  const [planOptions, setPlanOptions] = useState();
  useEffect(() => {
    const data = {};
    const params = { start: 0, recordSize: '' };
    planListView(data, params).then((res) => {
      const options = [];
      res.list.map((listData) => {
        options.push({
          id: listData.id,
          value: listData.name,
          label: listData.name,
          text: listData.name,
        });
      });
      setPlanOptions(options);
    });
  }, []);
  return (
    <div>
      <form form="startUpForm" onSubmit={handleSubmit(onButtonClick)}>
        <div className="row">
          <h6>{startupText}</h6>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="name">
                Startup name <span className="validation-icon">*</span>
              </label>
              <Field
                id="name"
                className="form-control"
                placeholder="Start Up Name"
                component={renderField}
                name="name"
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="rname">
                Startup registered name
                <span className="validation-icon">*</span>
              </label>
              <Field
                id="rname"
                className="form-control"
                placeholder="Enter name"
                component={renderField}
                name="registeredName"
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="fname">
                Founder name <span className="validation-icon">*</span>
              </label>
              <Field
                id="fname"
                className="form-control"
                placeholder="Enter Name"
                component={renderField}
                name="founderName"
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="fcnt">
                Founder contact number
                <span className="validation-icon">*</span>
              </label>
              <Field
                id="fcnt"
                name="mobile"
                type="number"
                className="form-control"
                component={renderField}
                validate={[required, IndMobileNumber]}
                placeholder="01234 56789"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="email">
                Founder Email ID
                <span className="validation-icon">*</span>
              </label>
              <Field
                id="email"
                className="form-control"
                placeholder="abc@xyz.com"
                component={renderField}
                name="email"
                validate={[required, email]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6" />
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="cname">
                CIIE PM Name <span className="validation-icon">*</span>
              </label>
              <Field
                id="cname"
                className="form-control"
                placeholder="Enter here"
                component={renderField}
                name="pocName"
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="cemail">
                PM Email ID <span className="validation-icon">*</span>
              </label>
              <Field
                id="cemail"
                className="form-control"
                placeholder="abc@xyz.com"
                component={renderField}
                name="pocEmail"
                validate={[required, email]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-3">
            <div className="form-group">
              <label htmlFor="plan">
                Program Alignment <span className="validation-icon">*</span>
              </label>
              <Field
                id="plan"
                type="dropdown"
                className="form-control"
                placeholder="-- select --"
                component={renderSelectForPlan}
                name="plan"
                options={planOptions}
                validate={[required]}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <Button disabled={invalid || processing || pristine} className="btn btn-red" type="submit">
                Submit
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'startUpForm',
});

export default withForm(StartUpForm);
